import Modal from "antd/lib/modal/Modal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideFullScreenOverlay,
  showFullScreenOverlay
} from "../../../store/actions/main/widgets";

import "./style.css";

const animationDuration = 0.5;

const VaporFullscreenOverlay = props => {
  const {
    children,
    hideMainPage,
    onClose,
    subtitle,
    title,
    visible,
    width,
    simulatePage,
    ...otherProps
  } = props;

  const fullscreenOverlayRedux = useSelector(state => state.main.widgets.fullscreenOverlay);

  const [visibleVar, setVisibleVar] = useState(visible);

  const dispatch = useDispatch();

  useEffect(() => {
    if (typeof visible === "undefined") {
      dispatch(showFullScreenOverlay({ ...otherProps }));
      setVisibleVar(true);
      //  document.getElementById("dbx-main-page").style("display", "none");
    }
  }, []);

  useEffect(() => {
    if (fullscreenOverlayRedux.visible) {
    }
  }, [fullscreenOverlayRedux]);

  useEffect(() => {
    setVisibleVar(visible);
  }, [visible]);

  useEffect(() => {
    if (visibleVar !== false) {
      dispatch(showFullScreenOverlay({ ...otherProps }));
      if (hideMainPage) {
        setTimeout(function() {
          document.getElementById("dbx-main-page").style.display = "none";
        }, animationDuration * 1000);
      }
    } else {
      dispatch(hideFullScreenOverlay());
      if (hideMainPage) {
        document.getElementById("dbx-main-page").style.display = null;
      }
    }
  }, [visibleVar]);

  if (visibleVar === false) {
    return null;
  }

  const closeComponent = () => {
    if (hideMainPage) {
      document.getElementById("dbx-main-page").style.display = null;
    }
    dispatch(hideFullScreenOverlay());
    setVisibleVar(false);
    onClose();
  };

  const renderModal = () => {
    return (
      <Modal
        className={
          !simulatePage
            ? "dbx-vapor-fullscreen-overlay-modal"
            : "dbx-vapor-fullscreen-overlay-modal-hide"
        }
        visible={visibleVar !== false}
        onCancel={closeComponent}
        maskClosable={false}
        centered
        wrapClassName={
          simulatePage ? "dbx-vapor-fullscreen-overlay-modal-wrapper" : ""
        }
        width={width}
        title={
          <div className="dbx-vapor-fullscreen-overlay-header headerPage">
            <div className="dbx-vapor-fullscreen-overlay-header-title title">
              <span className="textTitle">{title}</span>
              <div className="subtitle">{subtitle}</div>
            </div>{" "}
          </div>
        }
        footer={null}
        zIndex={99999999}
      >
        <div className={"dbx-vapor-fullscreen-overlay-body"}>{children}</div>
      </Modal>
    );
  };

  return renderModal();
};

export default VaporFullscreenOverlay;
